module.exports = {
    loyalty: {
        rewardsConversionBase: 200,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/royalty.js